module.exports = __webpack_public_path__ + "img/FPS.2bf87734.png";